import { useNavigate } from "react-router-dom";
import BatteryUnknown from "@mui/icons-material/BatteryUnknown";
import CalendarMonth from "@mui/icons-material/CalendarMonth";
import BarChartIcon from "@mui/icons-material/BarChart";
import LayersIcon from "@mui/icons-material/Layers";
import BatteryAlert from "@mui/icons-material/BatteryAlert";
import LocalTaxi from "@mui/icons-material/LocalTaxi";
import Dashboard from "@mui/icons-material/Dashboard";
import CurrencyYen from "@mui/icons-material/CurrencyYen";
import Work from "@mui/icons-material/Work";
import EngineeringIcon from "@mui/icons-material/Engineering";
import Lightbulb from "@mui/icons-material/Lightbulb";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import RequestQuote from "@mui/icons-material/RequestQuote";

import { MenuItem } from "@/components/atoms/MenuItem/MenuItem";
import { DisplayName } from "@/models/auth";
import { ManageAccounts } from "@mui/icons-material";

export const MenuListItems = () => {
  const navigate = useNavigate();
  const handleRedirect = (path: string) => {
    navigate(path);
  };

  return (
    <>
      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/"
        text="ダッシュボード"
        name={DisplayName.Dashboard}
      >
        <Dashboard />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/cars"
        text="車両"
        name={DisplayName.Cars}
      >
        <LocalTaxi />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/charger_exclude"
        text="充電器利用一時停止"
        name={DisplayName.ChargerExclude}
      >
        <BatteryAlert />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/driver_work_cycles"
        text="勤務シフト・勤務サイクル"
        name={DisplayName.DriverWorkCycles}
      >
        <Work />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/operation_plans"
        text="車両稼働予定"
        name={DisplayName.OperationPlans}
      >
        <CalendarMonth />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/charge_plans"
        text="充電計画"
        name={DisplayName.ChargePlans}
      >
        <CalendarMonth />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/charger_usage_status"
        text="充電器利用状況"
        name={DisplayName.ChargerUsageStatus}
      >
        <BatteryUnknown />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/quick_charger_remaining_time"
        text="急速充電器 残充電時間"
        name={DisplayName.QuickChargerRemainingTime}
      >
        <BatteryUnknown />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/contract_fee"
        text="契約料金"
        name={DisplayName.ContractFee}
      >
        <CurrencyYen />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/billing_payment_schedules"
        text="請求・支払日程"
        name={DisplayName.BillingPaymentSchedule}
      >
        <RequestQuote />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/charge_supply_days"
        text="充電電力量(日別)"
        name={DisplayName.ChargeSupplyDays}
      >
        <BarChartIcon />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/charge_supply_transactions"
        text="充電履歴"
        name={DisplayName.ChargeSupplyTransactions}
      >
        <LayersIcon />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/partner_users"
        text="ユーザー管理"
        name={DisplayName.PartnerUsers}
      >
        <ManageAccounts />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/accident_reports"
        text="事故報告"
        name={DisplayName.IncidentReport}
      >
        <EngineeringIcon />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/accident_report_persons"
        text="事故報告責任者"
        name={DisplayName.IncidentReport}
      >
        <AssignmentIndIcon />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/car_noop_events"
        text="日々の稼働確認"
        name={DisplayName.CarNoopEvents}
      >
        <LocalTaxi />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/car_underuse_events"
        text="月次の稼働確認"
        name={DisplayName.CarUnderuseEvents}
      >
        <LocalTaxi />
      </MenuItem>

      <MenuItem
        handleRedirect={(path: string) => handleRedirect(path)}
        path="/go_further"
        text="EV稼働・営収向上"
        name={DisplayName.RevenueSimulations}
      >
        <Lightbulb />
      </MenuItem>
    </>
  );
};
